
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/[entry]",
      function () {
        return require("private-next-pages/portfolio/[entry].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/[entry]"])
      });
    }
  